import { createTheme, responsiveFontSizes } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#61DAFB", // React blue
      light: "#88EEFC",
      dark: "#0891B2",
    },
    secondary: {
      main: "#C778DD", // Bright purple
    },
    background: {
      default: "#0D1117", // GitHub Dark default
      paper: "#161B22", // GitHub Dark paper
    },
    text: {
      primary: "#E6EDF3", // Bright text
      secondary: "#8B949E", // Muted text
    },
    syntax: {
      string: "#A5D6FF", // Strings
      function: "#D2A8FF", // Functions
      keyword: "#FF7B72", // Keywords
      comment: "#8B949E", // Comments
      variable: "#79C0FF", // Variables
    },
  },
  typography: {
    fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
    h1: {
      fontWeight: 600,
      letterSpacing: "-0.5px",
      color: "#E6EDF3",
    },
    h2: {
      fontWeight: 600,
      letterSpacing: "-0.5px",
    },
    h3: {
      fontWeight: 600,
      letterSpacing: "-0.5px",
    },
    body1: {
      letterSpacing: "0.15px",
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "#161B22",
          border: "1px solid #30363D",
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
          transition: "color 0.2s ease",
          "&:hover": {
            textDecoration: "none",
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "'JetBrains Mono', 'Fira Code', monospace",
        },
      },
    },
  },
});

theme = responsiveFontSizes(theme);

export default theme;
